import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.patients');
import { OnDestroy, OnInit } from '@angular/core';
import { HostListener } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-patients',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.patients/view.scss */
:host {
  container: wb-patients/inline-size;
  min-width: 0;
  display: block;
  min-height: 100%;
  background: var(--wb-page-canvas, #f5f9fd);
  color: var(--wb-ink, #102c3a);
}

.patient-manage-shell {
  width: min(100% - 40px, 1440px);
  margin-inline: auto;
}

.patient-manage-header {
  position: sticky;
  z-index: 20;
  top: 0;
  border-bottom: 1px solid var(--wb-border, #dce4e8);
  background: rgba(255, 255, 255, 0.98);
}

.patient-manage-header-inner {
  display: flex;
  min-height: 84px;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
}

.patient-manage-title-group,
.patient-manage-detail-code,
.patient-manage-code,
.patient-manage-detail-tags,
.patient-manage-quick-actions > div {
  display: flex;
  align-items: center;
}

.patient-manage-title-group {
  gap: 14px;
}

.patient-manage-title-icon {
  display: grid;
  width: 48px;
  height: 48px;
  place-items: center;
  border-radius: 14px;
  background: var(--wb-brand-soft, #eaf4fa);
  color: var(--wb-brand, #006aa6);
  font-size: 22px;
}

.patient-manage-title-group h1 {
  margin: 0;
  color: var(--wb-ink, #102c3a);
  font-size: 24px;
  font-weight: 800;
  line-height: 1.25;
}

.patient-manage-title-group p {
  margin: 5px 0 0;
  color: var(--wb-muted, #607381);
  font-size: 14px;
}

.patient-manage-primary,
.patient-manage-search-button,
.patient-manage-primary-action {
  border: 1px solid var(--wb-brand, #006aa6);
  background: var(--wb-brand, #006aa6);
  color: #fff;
  font-weight: 800;
}

.patient-manage-primary {
  display: inline-flex;
  min-height: 46px;
  align-items: center;
  gap: 9px;
  border-radius: 12px;
  padding: 0 20px;
  font-size: 15px;
}

.patient-manage-primary:hover,
.patient-manage-search-button:hover,
.patient-manage-primary-action:hover {
  border-color: var(--wb-brand-hover, #005585);
  background: var(--wb-brand-hover, #005585);
}

.patient-manage-page {
  padding-block: 16px 48px;
}

.patient-manage-privacy,
.patient-manage-error {
  display: flex;
  min-height: 52px;
  align-items: center;
  gap: 11px;
  border-radius: 10px;
  padding: 12px 18px;
  font-size: 14px;
}

.patient-manage-privacy {
  border: 1px solid var(--wb-brand-border, #b3d8eb);
  background: #f4faff;
  color: #075f96;
}

.patient-manage-privacy i {
  font-size: 17px;
}

.patient-manage-error {
  justify-content: space-between;
  margin-top: 14px;
  border: 1px solid #fecaca;
  background: #fef2f2;
  color: #b91c1c;
}

.patient-manage-error button {
  color: inherit;
  font-weight: 800;
  text-decoration: underline;
}

.patient-manage-toolbar {
  display: grid;
  grid-template-columns: minmax(260px, 1fr) 210px 210px 112px 90px;
  gap: 12px;
  margin-top: 18px;
  padding: 16px;
  border: 1px solid var(--wb-border, #dce4e8);
  border-radius: 12px;
  background: #fff;
}

.patient-manage-toolbar > *, .patient-manage-toolbar input, .patient-manage-toolbar select {
  min-width: 0;
}

.patient-manage-search {
  position: relative;
}

.patient-manage-search i {
  position: absolute;
  top: 50%;
  left: 16px;
  color: var(--wb-subtle, #84939d);
  transform: translateY(-50%);
}

.patient-manage-search input,
.patient-manage-select select,
.patient-manage-search-button,
.patient-manage-reset {
  width: 100%;
  min-height: 46px;
  border-radius: 9px;
  font-size: 14px;
}

.patient-manage-search input,
.patient-manage-select select {
  border: 1px solid var(--wb-border-strong, #cad6df);
  background: #fff;
  color: var(--wb-ink, #102c3a);
}

.patient-manage-search input {
  padding: 0 16px 0 44px;
}

.patient-manage-select select {
  padding: 0 38px 0 14px;
}

.patient-manage-search input::placeholder {
  color: var(--wb-subtle, #84939d);
}

.patient-manage-search-button,
.patient-manage-reset {
  padding-inline: 16px;
}

.patient-manage-reset {
  border: 1px solid var(--wb-border-strong, #cad6df);
  background: #fff;
  color: var(--wb-ink-soft, #3b5261);
  font-weight: 700;
}

.patient-manage-reset:hover {
  background: var(--wb-surface-muted, #f7f9fa);
}

.patient-manage-workspace {
  display: grid;
  grid-template-columns: minmax(0, 1.72fr) minmax(360px, 1fr);
  gap: 16px;
  margin-top: 18px;
  align-items: stretch;
}

.patient-manage-list,
.patient-manage-detail {
  min-width: 0;
  overflow: hidden;
  border: 1px solid var(--wb-border, #dce4e8);
  border-radius: 12px;
  background: #fff;
}

.patient-manage-list {
  min-width: 0;
}

.patient-manage-section-header {
  display: flex;
  min-height: 64px;
  align-items: center;
  justify-content: space-between;
  padding: 0 24px;
  border-bottom: 1px solid var(--wb-border, #dce4e8);
}

.patient-manage-section-header h2,
.patient-manage-detail-heading h2 {
  margin: 0;
  color: var(--wb-ink, #102c3a);
  font-weight: 800;
}

.patient-manage-section-header h2 {
  font-size: 18px;
}

.patient-manage-section-header span,
.patient-manage-list-footer > span {
  color: var(--wb-muted, #607381);
  font-size: 13px;
}

.patient-manage-loading,
.patient-manage-empty {
  display: flex;
  min-height: 390px;
  align-items: center;
  justify-content: center;
  color: var(--wb-muted, #607381);
}

.patient-manage-loading {
  gap: 10px;
  font-size: 14px;
}

.patient-manage-empty {
  flex-direction: column;
  gap: 10px;
  padding: 32px;
  text-align: center;
}

.patient-manage-empty > i {
  color: var(--wb-subtle, #84939d);
  font-size: 28px;
}

.patient-manage-empty p {
  margin: 0;
  font-size: 14px;
}

.patient-manage-empty button {
  min-height: 40px;
  border: 1px solid var(--wb-brand-border, #b3d8eb);
  border-radius: 8px;
  padding: 0 16px;
  background: #fff;
  color: var(--wb-brand, #006aa6);
  font-weight: 800;
}

.patient-manage-table-wrap {
  max-width: 100%;
  overflow-x: auto;
  overscroll-behavior-x: contain;
}

.patient-manage-table-wrap:focus-visible {
  outline: 2px solid var(--wb-brand, #006aa6);
  outline-offset: -3px;
}

.patient-manage-table {
  min-width: 640px;
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.patient-manage-table th,
.patient-manage-table td {
  word-break: keep-all;
  overflow-wrap: anywhere;
  border-bottom: 1px solid var(--wb-border, #dce4e8);
  text-align: left;
}

.patient-manage-table th {
  height: 50px;
  padding: 0 20px;
  background: var(--wb-surface-muted, #f7f9fa);
  color: var(--wb-muted, #607381);
  font-size: 12px;
  font-weight: 800;
}

.patient-manage-table td {
  height: 68px;
  padding: 10px 20px;
  color: var(--wb-ink-soft, #3b5261);
  font-size: 13px;
  transition: background-color 140ms ease;
}

.patient-manage-table th:nth-child(1) {
  width: 34%;
}

.patient-manage-table th:nth-child(2) {
  width: 22%;
}

.patient-manage-table th:nth-child(3) {
  width: 22%;
}

.patient-manage-table th:nth-child(4) {
  width: 22%;
}

.patient-manage-table tbody tr {
  cursor: pointer;
}

.patient-manage-table tbody tr:hover td {
  background: #f7fbfd;
}

.patient-manage-table tbody tr.is-selected td {
  background: #eef9f8;
}

.patient-manage-code {
  gap: 7px;
}

.patient-manage-code strong {
  color: var(--wb-ink, #102c3a);
  font-size: 14px;
  overflow-wrap: anywhere;
}

.patient-readiness {
  display: inline-flex;
  min-height: 28px;
  align-items: center;
  gap: 6px;
  border: 1px solid transparent;
  border-radius: 999px;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 800;
  white-space: nowrap;
}

.patient-readiness.is-ready {
  border-color: #b7ebcc;
  background: #edfbf3;
  color: #08764f;
}

.patient-readiness.is-review {
  border-color: #f5d491;
  background: #fff8e8;
  color: #9a5c00;
}

.patient-manage-list-footer {
  display: flex;
  min-height: 68px;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
}

.patient-manage-pagination {
  display: flex;
  gap: 8px;
}

.patient-manage-pagination button,
.patient-manage-icon-button {
  display: grid;
  place-items: center;
  border: 1px solid var(--wb-border, #dce4e8);
  background: #fff;
  color: var(--wb-ink-soft, #3b5261);
}

.patient-manage-pagination button {
  min-width: 38px;
  height: 38px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 800;
}

.patient-manage-pagination button.is-active {
  border-color: var(--wb-brand, #006aa6);
  background: var(--wb-brand, #006aa6);
  color: #fff;
}

.patient-manage-pagination button:disabled {
  cursor: not-allowed;
  opacity: 0.42;
}

.patient-manage-mobile-list {
  display: none;
}

.patient-manage-detail {
  min-height: 594px;
  padding: 24px;
}

.patient-manage-detail-heading {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.patient-manage-detail-code {
  min-width: 0;
  gap: 8px;
}

.patient-manage-detail-heading h2 {
  font-size: clamp(18px, 1.7vw, 24px);
  overflow-wrap: anywhere;
}

.patient-manage-icon-button {
  width: 40px;
  height: 40px;
  border-radius: 9px;
}

.patient-manage-action-menu {
  position: relative;
}

.patient-manage-action-popover {
  position: absolute;
  z-index: 5;
  top: 46px;
  right: 0;
  width: 150px;
  overflow: hidden;
  border: 1px solid var(--wb-border, #dce4e8);
  border-radius: 9px;
  background: #fff;
  box-shadow: 0 12px 30px rgba(16, 44, 58, 0.14);
}

.patient-manage-action-popover button {
  display: flex;
  width: 100%;
  min-height: 44px;
  align-items: center;
  gap: 10px;
  padding: 0 14px;
  color: var(--wb-ink, #102c3a);
  font-size: 13px;
  text-align: left;
}

.patient-manage-action-popover button:hover {
  background: var(--wb-surface-muted, #f7f9fa);
}

.patient-manage-detail-tags {
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 14px;
}

.patient-manage-detail-tags > span:not(.patient-readiness) {
  min-height: 28px;
  border-radius: 999px;
  padding: 5px 11px;
  background: var(--wb-surface-strong, #e8eef2);
  color: var(--wb-ink-soft, #3b5261);
  font-size: 12px;
  font-weight: 700;
}

.patient-manage-detail-section,
.patient-manage-quick-actions {
  margin-top: 24px;
  padding-top: 22px;
  border-top: 1px solid var(--wb-border, #dce4e8);
}

.patient-manage-detail-section h3,
.patient-manage-quick-actions h3 {
  display: flex;
  align-items: center;
  gap: 9px;
  margin: 0 0 13px;
  color: var(--wb-ink, #102c3a);
  font-size: 15px;
  font-weight: 800;
}

.patient-manage-detail-section h3 i,
.patient-manage-quick-actions h3 i {
  color: var(--wb-brand, #006aa6);
}

.patient-manage-trauma-summary,
.patient-manage-recent {
  display: flex;
  min-height: 78px;
  align-items: center;
  border: 1px solid var(--wb-border, #dce4e8);
  border-radius: 10px;
  padding: 14px 16px;
  background: var(--wb-surface-muted, #f7f9fa);
}

.patient-manage-trauma-summary span,
.patient-manage-trauma-summary strong,
.patient-manage-trauma-summary small {
  display: block;
}

.patient-manage-trauma-summary strong,
.patient-manage-recent strong {
  color: var(--wb-ink, #102c3a);
  font-size: 14px;
}

.patient-manage-trauma-summary small,
.patient-manage-recent p,
.patient-manage-quick-actions > p {
  margin: 5px 0 0;
  color: var(--wb-muted, #607381);
  font-size: 12px;
  line-height: 1.45;
}

.patient-manage-recent {
  display: block;
}

.patient-manage-quick-actions > div {
  gap: 10px;
}

.patient-manage-primary-action,
.patient-manage-secondary-action {
  display: inline-flex;
  min-height: 48px;
  flex: 1 1 0;
  align-items: center;
  justify-content: center;
  gap: 8px;
  border-radius: 9px;
  padding: 0 12px;
  font-size: 13px;
  font-weight: 800;
}

.patient-manage-secondary-action {
  border: 1px solid var(--wb-brand, #006aa6);
  background: #fff;
  color: var(--wb-brand, #006aa6);
}

.patient-manage-secondary-action:hover {
  background: var(--wb-brand-soft, #eaf4fa);
}

.patient-manage-detail-empty {
  display: grid;
  place-items: center;
  align-content: center;
  gap: 12px;
  color: var(--wb-muted, #607381);
  text-align: center;
}

.patient-manage-detail-empty i {
  font-size: 30px;
}

.patient-manage-detail-empty p {
  margin: 0;
  font-size: 14px;
}

.patient-manage-search input:focus-visible,
.patient-manage-select select:focus-visible,
.patient-manage-toolbar button:focus-visible,
.patient-manage-primary:focus-visible,
.patient-manage-table tbody tr:focus-visible,
.patient-manage-pagination button:focus-visible,
.patient-manage-detail button:focus-visible,
.patient-manage-empty button:focus-visible {
  outline: 3px solid var(--wb-brand-border, #b3d8eb);
  outline-offset: 2px;
}

@container wb-patients (max-width: 1180px) {
  .patient-manage-toolbar {
    grid-template-columns: minmax(240px, 1fr) 170px 170px 96px 82px;
  }
  .patient-manage-workspace {
    grid-template-columns: minmax(0, 1.5fr) minmax(330px, 1fr);
  }
  .patient-manage-table th,
  .patient-manage-table td {
    padding-inline: 14px;
  }
}
@container wb-patients (max-width: 980px) {
  .patient-manage-toolbar {
    grid-template-columns: 1fr 1fr;
  }
  .patient-manage-search {
    grid-column: 1/-1;
  }
  .patient-manage-workspace {
    grid-template-columns: 1fr;
  }
  .patient-manage-detail {
    min-height: 0;
  }
}
@container wb-patients (max-width: 680px) {
  .patient-manage-shell {
    width: min(100% - 24px, 1440px);
  }
  .patient-manage-header-inner {
    min-height: 76px;
  }
  .patient-manage-title-icon {
    width: 42px;
    height: 42px;
    font-size: 19px;
  }
  .patient-manage-title-group h1 {
    font-size: 20px;
  }
  .patient-manage-title-group p {
    display: none;
  }
  .patient-manage-primary {
    min-height: 42px;
    padding-inline: 13px;
  }
  .patient-manage-privacy {
    align-items: flex-start;
    font-size: 13px;
  }
  .patient-manage-toolbar {
    grid-template-columns: 1fr;
  }
  .patient-manage-search {
    grid-column: auto;
  }
  .patient-manage-table-wrap {
    display: none;
  }
  .patient-manage-mobile-list {
    display: block;
  }
  .patient-manage-mobile-row {
    display: flex;
    width: 100%;
    min-height: 78px;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    flex-wrap: wrap;
    padding: 12px 16px;
    border-bottom: 1px solid var(--wb-border, #dce4e8);
    background: #fff;
    text-align: left;
  }
  .patient-manage-mobile-row.is-selected {
    background: #eef9f8;
  }
  .patient-manage-mobile-row > span:first-child {
    min-width: 0;
  }
  .patient-manage-mobile-row strong,
  .patient-manage-mobile-row small {
    display: block;
  }
  .patient-manage-mobile-row strong {
    color: var(--wb-ink, #102c3a);
    font-size: 13px;
    overflow-wrap: anywhere;
  }
  .patient-manage-mobile-row small {
    margin-top: 5px;
    color: var(--wb-muted, #607381);
    font-size: 11px;
  }
  .patient-manage-list-footer {
    align-items: flex-start;
    flex-direction: column;
    gap: 12px;
  }
  .patient-manage-detail {
    padding: 20px;
  }
  .patient-manage-quick-actions > div {
    align-items: stretch;
    flex-direction: column;
  }
}
.patient-form-overlay {
  position: fixed;
  z-index: 60;
  inset: 0;
  display: grid;
  overflow-y: auto;
  place-items: safe center;
  padding: 24px;
  background: rgba(15, 35, 48, 0.54);
  backdrop-filter: blur(3px);
}

.patient-form-dialog {
  display: grid;
  width: min(900px, 100%);
  max-height: min(760px, 100vh - 48px);
  grid-template-columns: minmax(280px, 0.74fr) minmax(0, 1.36fr);
  overflow: hidden;
  border: 1px solid rgba(202, 214, 223, 0.9);
  border-radius: 16px;
  background: #fff;
  box-shadow: 0 28px 80px rgba(16, 44, 58, 0.28);
}

.patient-form-privacy {
  display: flex;
  min-height: 610px;
  flex-direction: column;
  padding: 48px 40px 40px;
  background: #eef8fd;
}

.patient-form-eyebrow {
  margin: 0 0 8px;
  color: var(--wb-brand, #006aa6);
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.patient-form-privacy h3,
.patient-form-header h3 {
  margin: 0;
  color: var(--wb-ink, #102c3a);
  font-weight: 800;
}

.patient-form-privacy h3 {
  font-size: 23px;
  line-height: 1.35;
}

.patient-form-privacy-copy {
  margin: 12px 0 0;
  color: var(--wb-muted, #607381);
  font-size: 13px;
  line-height: 1.65;
}

.patient-form-shield {
  display: grid;
  width: 108px;
  height: 108px;
  flex: 0 0 auto;
  place-items: center;
  align-self: center;
  margin-block: 52px auto;
  border-radius: 50%;
  background: #dff1fb;
  color: var(--wb-brand, #006aa6);
  font-size: 46px;
}

.patient-form-code {
  position: relative;
  padding-top: 22px;
  border-top: 1px solid var(--wb-brand-border, #b3d8eb);
}

.patient-form-code span,
.patient-form-code strong,
.patient-form-code small {
  display: block;
}

.patient-form-code span {
  color: var(--wb-muted, #607381);
  font-size: 12px;
  font-weight: 700;
}

.patient-form-code strong {
  margin-top: 8px;
  color: var(--wb-ink, #102c3a);
  font-size: 15px;
}

.patient-form-code small {
  margin-top: 9px;
  color: var(--wb-muted, #607381);
  font-size: 11px;
}

.patient-form-code wiz-component-patient-code-copy {
  position: absolute;
  right: 0;
  bottom: -3px;
}

.patient-form-main {
  display: flex;
  min-width: 0;
  min-height: 0;
  flex-direction: column;
  background: #fff;
}

.patient-form-header {
  display: flex;
  min-height: 82px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  padding: 0 34px;
  border-bottom: 1px solid var(--wb-border, #dce4e8);
}

.patient-form-header h3 {
  font-size: 21px;
}

.patient-form-close {
  display: grid;
  width: 42px;
  height: 42px;
  place-items: center;
  border: 1px solid transparent;
  border-radius: 10px;
  color: var(--wb-muted, #607381);
  font-size: 19px;
}

.patient-form-close:hover {
  border-color: var(--wb-border, #dce4e8);
  background: var(--wb-surface-muted, #f7f9fa);
  color: var(--wb-ink, #102c3a);
}

.patient-form-body {
  min-height: 0;
  flex: 1 1 auto;
  overflow-y: auto;
  padding: 28px 34px 30px;
}

.patient-form-row {
  display: grid;
  grid-template-columns: 126px minmax(0, 1fr);
  align-items: center;
  gap: 18px;
}

.patient-form-row + .patient-form-row {
  margin-top: 20px;
}

.patient-form-row-start {
  align-items: start;
}

.patient-form-row > label {
  color: var(--wb-ink, #102c3a);
  font-size: 13px;
  font-weight: 800;
}

.patient-form-row-start > label {
  padding-top: 14px;
}

.patient-form-control-stack {
  position: relative;
  min-width: 0;
}

.patient-form-control {
  width: 100%;
  min-height: 50px;
  border: 1px solid var(--wb-border-strong, #cad6df);
  border-radius: 10px;
  background: #fff;
  color: var(--wb-ink, #102c3a);
  font-size: 13px;
}

input.patient-form-control,
select.patient-form-control {
  padding: 0 14px;
}

.patient-form-control:hover {
  border-color: #9db2c0;
}

.patient-form-control:focus,
.patient-form-control:focus-visible,
.patient-form-close:focus-visible,
.patient-form-footer button:focus-visible,
.patient-form-options button:focus-visible,
.patient-form-option-search input:focus-visible {
  outline: 3px solid var(--wb-brand-border, #b3d8eb);
  outline-offset: 2px;
}

.patient-form-other {
  margin-top: 10px;
}

.patient-form-other p,
.patient-form-help,
.patient-form-error {
  margin: 7px 0 0;
  font-size: 11px;
  line-height: 1.5;
}

.patient-form-other p,
.patient-form-help {
  color: var(--wb-muted, #607381);
}

.patient-form-error {
  color: #b91c1c;
}

.patient-form-select-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 0 14px;
  text-align: left;
}

.patient-form-select-button > i {
  flex: 0 0 auto;
  color: var(--wb-subtle, #84939d);
  font-size: 11px;
}

.patient-form-therapist-value {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 9px;
}

.patient-form-therapist-value strong {
  overflow: hidden;
  font-size: 13px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.patient-form-therapist-value small {
  flex: 0 0 auto;
  color: var(--wb-muted, #607381);
  font-size: 11px;
}

.patient-form-self {
  display: grid;
  width: 30px;
  height: 30px;
  flex: 0 0 auto;
  place-items: center;
  border-radius: 50%;
  background: var(--wb-brand-soft, #eaf4fa);
  color: var(--wb-brand, #006aa6);
  font-size: 11px;
  font-weight: 800;
}

.patient-form-placeholder {
  color: var(--wb-subtle, #84939d);
}

.patient-form-options {
  position: absolute;
  z-index: 4;
  top: calc(100% + 8px);
  right: 0;
  left: 0;
  overflow: hidden;
  border: 1px solid var(--wb-border-strong, #cad6df);
  border-radius: 10px;
  background: #fff;
  box-shadow: 0 16px 32px rgba(16, 44, 58, 0.16);
}

.patient-form-option-search {
  display: flex;
  min-height: 46px;
  align-items: center;
  gap: 10px;
  padding: 0 14px;
  border-bottom: 1px solid var(--wb-border, #dce4e8);
  color: var(--wb-subtle, #84939d);
}

.patient-form-option-search input {
  width: 100%;
  min-width: 0;
  border: 0;
  background: transparent;
  color: var(--wb-ink, #102c3a);
  font-size: 12px;
  outline: 0;
}

.patient-form-option-list {
  max-height: 176px;
  overflow-y: auto;
  padding-block: 5px;
}

.patient-form-option-list button {
  display: flex;
  width: 100%;
  min-height: 44px;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 7px 14px;
  text-align: left;
}

.patient-form-option-list button:hover,
.patient-form-option-list button[aria-pressed=true] {
  background: var(--wb-brand-soft, #eaf4fa);
}

.patient-form-option-list button span {
  display: flex;
  min-width: 0;
  align-items: center;
  gap: 8px;
}

.patient-form-option-list strong {
  overflow: hidden;
  color: var(--wb-ink, #102c3a);
  font-size: 12px;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.patient-form-option-list small {
  border-radius: 999px;
  padding: 3px 7px;
  background: var(--wb-brand-soft, #eaf4fa);
  color: var(--wb-brand, #006aa6);
  font-size: 10px;
  font-weight: 800;
}

.patient-form-option-list em {
  flex: 0 0 auto;
  color: var(--wb-muted, #607381);
  font-size: 11px;
  font-style: normal;
}

.patient-form-option-list > p {
  margin: 0;
  padding: 20px 14px;
  color: var(--wb-muted, #607381);
  font-size: 12px;
  text-align: center;
}

.patient-form-footer {
  display: flex;
  min-height: 78px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  padding: 14px 34px;
  border-top: 1px solid var(--wb-border, #dce4e8);
  background: #fff;
}

.patient-form-footer button {
  min-height: 44px;
  border-radius: 9px;
  padding: 0 18px;
  font-size: 13px;
  font-weight: 800;
}

.patient-form-cancel {
  border: 1px solid var(--wb-border-strong, #cad6df);
  background: #fff;
  color: var(--wb-ink-soft, #3b5261);
}

.patient-form-cancel:hover {
  background: var(--wb-surface-muted, #f7f9fa);
}

.patient-form-submit {
  border: 1px solid var(--wb-brand, #006aa6);
  background: var(--wb-brand, #006aa6);
  color: #fff;
}

.patient-form-submit:hover {
  border-color: var(--wb-brand-hover, #005585);
  background: var(--wb-brand-hover, #005585);
}

.patient-form-footer button:disabled,
.patient-form-close:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

@container wb-patients (max-width: 760px) {
  .patient-form-overlay {
    place-items: start center;
    padding: 12px;
  }
  .patient-form-dialog {
    max-height: calc(100vh - 24px);
    grid-template-columns: 1fr;
    overflow-y: auto;
  }
  .patient-form-privacy {
    min-height: auto;
    padding: 24px;
  }
  .patient-form-privacy h3 {
    font-size: 19px;
  }
  .patient-form-shield {
    display: none;
  }
  .patient-form-code {
    margin-top: 22px;
    padding-top: 18px;
  }
  .patient-form-main {
    overflow: visible;
  }
  .patient-form-header,
  .patient-form-body,
  .patient-form-footer {
    padding-inline: 22px;
  }
  .patient-form-body {
    overflow: visible;
  }
  .patient-form-row {
    grid-template-columns: 1fr;
    gap: 8px;
  }
  .patient-form-row-start > label {
    padding-top: 0;
  }
}
.pane-table-hint {
  margin: 0;
  padding: 8px 14px;
  color: #526d8c;
  font-size: 12px;
  line-height: 1.5;
}

.patient-form-overlay {
  grid-template-rows: minmax(0, 1fr);
}

.patient-form-dialog {
  max-height: 100%;
  min-height: 0;
}`],
})
export class PagePatientsComponent implements OnInit, OnDestroy {
    public loading: boolean = false;
    public saving: boolean = false;
    public errorMessage: string = '';
    public patients: any[] = [];
    public total: number = 0;
    public currentYear: number = new Date().getFullYear();
    public currentDate: string = new Date().toISOString().slice(0, 10);
    public traumaTypeDetailMaxLength: number = 80;
    public csrfToken: string = '';
    public therapists: any[] = [];
    public currentUserId: string = '';
    public therapistSearch: string = '';
    public therapistMenuOpen: boolean = false;
    public formOptionsError: string = '';
    public selectedPatientId: string = '';
    public actionMenuPatientId: string = '';
    private loadSequence: number = 0;
    private formReturnFocus: HTMLElement | null = null;
    private createQuerySubscription: Subscription | null = null;

    public search: any = {
        text: '',
        status: 'active',
        trauma_type: '',
        page: 1,
        dump: 10
    };

    public showFormModal: boolean = false;
    public form: any = this.emptyForm();
    public genders: any[] = [
        { value: 'unspecified', label: '미응답' },
        { value: 'female', label: '여성' },
        { value: 'male', label: '남성' },
        { value: 'other', label: '기타' }
    ];

    public traumaTypes: any[] = [
        { value: 'traffic_accident', label: '교통사고' },
        { value: 'flight_related', label: '비행 관련' },
        { value: 'disaster_accident', label: '재난·사고' },
        { value: 'violence_crime', label: '폭력·범죄' },
        { value: 'loss_bereavement', label: '상실·사별' },
        { value: 'other', label: '기타' }
    ];

    public scenarioTypes: any[] = [
        { value: '', label: '미지정' }
    ];

    constructor(@Inject( Service) public service: Service,@Inject( ActivatedRoute)  private route: ActivatedRoute,@Inject( Router)  private router: Router) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow('/access');
        await this.load(1);
        this.createQuerySubscription = this.route.queryParamMap.subscribe((params) => {
            if (params.get('create') !== '1') return;
            void this.router.navigate(['/patients'], { replaceUrl: true });
            void this.openCreate(false);
        });
    }

    public ngOnDestroy() {
        this.createQuerySubscription?.unsubscribe();
    }

    public emptyForm() {
        return {
            id: '',
            patient_code: '',
            row_version: 1,
            birth_date: '',
            birth_year: '',
            gender: 'unspecified',
            trauma_type: 'traffic_accident',
            trauma_type_detail: '',
            assigned_user_id: ''
        };
    }

    public message(data: any, fallback: string) {
        if (typeof data === 'string') return data;
        return data?.message || fallback;
    }

    public async load(page: number = this.search.page) {
        const sequence = ++this.loadSequence;
        this.loading = true;
        this.errorMessage = '';
        this.search.page = page;
        await this.service.render();

        try {
            const { code, data } = await wiz.call('search', this.search);
            if (sequence !== this.loadSequence) return;
            if (code === 200) {
                this.patients = data.rows || [];
                this.total = data.total || 0;
                if (!this.patients.some((patient: any) => patient.id === this.selectedPatientId)) {
                    this.selectedPatientId = this.patients[0]?.id || '';
                }
                this.actionMenuPatientId = '';
                this.therapists = data.therapists || [];
                this.currentUserId = data.current_user_id || '';
                this.scenarioTypes = [
                    { value: '', label: '미지정' },
                    ...(data.scenario_options || [])
                ];
                this.formOptionsError = this.therapists.length > 0
                    ? ''
                    : '선택할 수 있는 담당 치료자가 없습니다.';
                this.csrfToken = data.csrf_token || '';
                const lastPage = Math.max(1, Math.ceil(this.total / this.search.dump));
                if (this.search.page > lastPage) {
                    await this.load(lastPage);
                }
                return;
            }
            this.errorMessage = this.message(data, '환자 목록을 불러오지 못했습니다.');
        } catch (error) {
            this.errorMessage = '환자 목록을 불러오지 못했습니다.';
        } finally {
            if (sequence !== this.loadSequence) return;
            this.loading = false;
            await this.service.render();
        }
    }

    public async resetFilters() {
        this.search = { text: '', status: 'active', trauma_type: '', page: 1, dump: 10 };
        await this.load(1);
    }

    public async selectPatient(patient: any) {
        const id = String(patient?.id || '');
        if (!id || id === this.selectedPatientId) return;
        this.selectedPatientId = id;
        this.actionMenuPatientId = '';
        await this.service.render();
    }

    public selectedPatient() {
        return this.patients.find(
            (patient: any) => patient.id === this.selectedPatientId
        ) || null;
    }

    public async togglePatientActions(patient: any, event?: Event) {
        event?.stopPropagation();
        const id = String(patient?.id || '');
        this.actionMenuPatientId = this.actionMenuPatientId === id ? '' : id;
        await this.service.render();
    }

    public closePatientActions() {
        this.actionMenuPatientId = '';
    }

    @HostListener('document:click')
    public async closePatientActionsFromOutside() {
        if (!this.actionMenuPatientId) return;
        this.actionMenuPatientId = '';
        await this.service.render();
    }

    public openPatientDetail(patient: any) {
        const patientId = String(patient?.id || '').trim().toLowerCase();
        if (!/^[0-9a-f]{32}$/.test(patientId)) return;
        this.service.href(`/patients/${encodeURIComponent(patientId)}`);
    }

    public startPatientWork(patient: any) {
        const patientId = String(patient?.id || '').trim().toLowerCase();
        if (!/^[0-9a-f]{32}$/.test(patientId)) return;
        if (!this.patientContentReady(patient)) {
            this.openPatientDetail(patient);
            return;
        }
        this.service.href(`/content?patient_id=${encodeURIComponent(patientId)}`);
    }

    public async openCreate(reloadOptions: boolean = true) {
        this.formReturnFocus = document.activeElement instanceof HTMLElement
            ? document.activeElement
            : null;
        if (reloadOptions) await this.load(this.search.page);
        if (this.therapists.length === 0) {
            await this.service.modal.error(
                this.formOptionsError || '선택할 수 있는 담당 치료자가 없습니다.'
            );
            return;
        }
        this.form = this.emptyForm();
        this.form.assigned_user_id = this.currentUserId || this.therapists[0]?.id || '';
        this.therapistSearch = '';
        this.therapistMenuOpen = false;
        this.showFormModal = true;
        await this.service.render();
        document.getElementById('patient-birth-date')?.focus();
    }

    public async openEdit(patient: any) {
        this.formReturnFocus = document.activeElement instanceof HTMLElement
            ? document.activeElement
            : null;
        this.form = {
            id: patient.id,
            patient_code: patient.patient_code,
            row_version: patient.row_version,
            birth_date: patient.birth_date || '',
            birth_year: patient.birth_year || '',
            gender: patient.gender || 'unspecified',
            trauma_type: patient.trauma_type,
            trauma_type_detail: patient.trauma_type_detail || '',
            assigned_user_id: patient.assigned_user_id || this.currentUserId || ''
        };
        this.therapistSearch = '';
        this.therapistMenuOpen = false;
        this.showFormModal = true;
        await this.service.render();
        document.getElementById('patient-birth-date')?.focus();
    }

    public async openPatient(patient: any, event?: Event) {
        const target = event?.target;
        if (
            target instanceof Element
            && target.closest('button, a, input, select, textarea')
        ) return;
        const patientId = String(patient?.id || '').trim().toLowerCase();
        if (!/^[0-9a-f]{32}$/.test(patientId)) return;
        this.service.href(`/patients/${encodeURIComponent(patientId)}`);
    }

    public async closeForm() {
        if (this.saving) return;
        this.showFormModal = false;
        this.therapistMenuOpen = false;
        await this.service.render();
        const target = this.formReturnFocus;
        this.formReturnFocus = null;
        setTimeout(() => target?.focus(), 0);
    }

    public onFormKeydown(event: KeyboardEvent) {
        if (event.key !== 'Tab') return;
        const dialog = document.getElementById('patient-form-dialog');
        if (!dialog) return;
        const focusable = Array.from(dialog.querySelectorAll<HTMLElement>(
            'button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
        )).filter((element) => element.offsetParent !== null);
        if (focusable.length === 0) {
            event.preventDefault();
            dialog.focus();
            return;
        }
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
            event.preventDefault();
            last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
            event.preventDefault();
            first.focus();
        }
    }

    @HostListener('document:keydown.escape')
    public async closeFormWithEscape() {
        if (this.showFormModal && !this.saving) await this.closeForm();
        else if (this.actionMenuPatientId) {
            this.actionMenuPatientId = '';
            await this.service.render();
        }
    }

    public async save() {
        if (this.saving) return;
        if (!this.form.assigned_user_id) {
            await this.service.modal.error('담당 치료자를 선택해주세요.');
            return;
        }
        if (!this.form.trauma_type) {
            await this.service.modal.error('외상 유형을 선택해주세요.');
            return;
        }
        const traumaTypeDetail = String(this.form.trauma_type_detail || '').trim();
        if (this.form.trauma_type === 'other' && !traumaTypeDetail) {
            await this.service.modal.error('기타 외상 유형을 입력해주세요.');
            return;
        }
        if (traumaTypeDetail.length > this.traumaTypeDetailMaxLength) {
            await this.service.modal.error('기타 외상 유형은 80자 이내로 입력해주세요.');
            return;
        }
        this.form.trauma_type_detail = this.form.trauma_type === 'other'
            ? traumaTypeDetail
            : '';

        if (
            this.form.birth_date
            && (
                String(this.form.birth_date) < '1900-01-01'
                || String(this.form.birth_date) > this.currentDate
            )
        ) {
            await this.service.modal.error('출생년월일을 확인해주세요.');
            return;
        }

        this.saving = true;
        await this.service.render();
        try {
            const { code, data } = await wiz.call('save', {
                ...this.form,
                expected_version: this.form.id ? this.form.row_version : '',
                csrf_token: this.csrfToken
            });
            if (code === 200) {
                const created = !this.form.id;
                await this.service.modal.success(created ? '환자가 등록되었습니다.' : '환자 정보가 수정되었습니다.');
                this.showFormModal = false;
                const target = this.formReturnFocus;
                this.formReturnFocus = null;
                if (created && data?.patient?.id) {
                    this.service.href(
                        `/patients/${encodeURIComponent(data.patient.id)}?start=scenario`
                    );
                    return;
                }
                await this.load(this.search.page);
                setTimeout(() => target?.focus(), 0);
                return;
            }
            if (code === 409) {
                await this.service.modal.error(
                    this.message(
                        data,
                        '다른 사용자가 환자 정보를 수정했습니다. 목록을 새로고침한 뒤 다시 시도해주세요.'
                    )
                );
                await this.load(this.search.page);
                return;
            }
            await this.service.modal.error(this.message(data, '환자 정보를 저장하지 못했습니다.'));
        } catch (error) {
            await this.service.modal.error('환자 정보를 저장하지 못했습니다.');
        } finally {
            this.saving = false;
            await this.service.render();
        }
    }

    public async toggleStatus(patient: any) {
        const nextStatus = patient.status === 'archived' ? 'active' : 'archived';
        const action = nextStatus === 'archived' ? '보관' : '활성화';
        const confirmed = await this.service.modal.show({
            title: `환자 ${action}`,
            message: `${patient.patient_code} 환자를 ${action}하시겠습니까?`,
            action: action,
            actionBtn: nextStatus === 'archived' ? 'error' : 'success',
            status: nextStatus === 'archived' ? 'error' : 'success'
        });
        if (!confirmed) return;

        try {
            const { code, data } = await wiz.call('set_status', {
                id: patient.id,
                status: nextStatus,
                expected_version: patient.row_version,
                csrf_token: this.csrfToken
            });
            if (code === 200) {
                await this.load(this.search.page);
                return;
            }
            if (code === 409) {
                await this.service.modal.error(
                    this.message(
                        data,
                        '다른 사용자가 환자 상태를 변경했습니다. 최신 목록을 다시 불러옵니다.'
                    )
                );
                await this.load(this.search.page);
                return;
            }
            await this.service.modal.error(this.message(data, '환자 상태를 변경하지 못했습니다.'));
        } catch (error) {
            await this.service.modal.error('환자 상태를 변경하지 못했습니다.');
        }
    }

    public async onTraumaTypeChange(value: string) {
        this.form.trauma_type = value;
        if (value !== 'other') this.form.trauma_type_detail = '';
        await this.service.render();
        if (value === 'other') {
            setTimeout(() => document.getElementById('patient-trauma-type-detail')?.focus(), 0);
        }
    }

    public filteredTherapists() {
        const keyword = String(this.therapistSearch || '').trim().toLocaleLowerCase();
        if (!keyword) return this.therapists;
        return this.therapists.filter((therapist: any) => (
            `${therapist.name || ''} ${therapist.role || ''} ${this.roleLabel(therapist.role)}`
                .toLocaleLowerCase()
                .includes(keyword)
        ));
    }

    public selectedTherapist() {
        return this.therapists.find(
            (therapist: any) => therapist.id === this.form.assigned_user_id
        );
    }

    public roleLabel(role: string) {
        if (role === 'admin') return '관리자';
        if (role === 'therapist') return '담당 치료자';
        return '의료진';
    }

    public async toggleTherapistMenu() {
        this.therapistMenuOpen = !this.therapistMenuOpen;
        await this.service.render();
        if (this.therapistMenuOpen) {
            setTimeout(() => document.getElementById('patient-therapist-search')?.focus(), 0);
        }
    }

    public async selectTherapist(therapist: any) {
        this.form.assigned_user_id = therapist.id;
        this.therapistSearch = '';
        this.therapistMenuOpen = false;
        await this.service.render();
    }

    public traumaTypeLabel(patient: any) {
        if (patient?.trauma_type === 'other' && patient?.trauma_type_detail) {
            return patient.trauma_type_detail;
        }
        return this.labelOf(this.traumaTypes, patient?.trauma_type);
    }

    public patientContentReady(patient: any) {
        return patient?.content_ready === true;
    }

    public patientUpdatedDate(patient: any) {
        return String(patient?.updated || patient?.created || '').slice(0, 10) || '-';
    }

    public patientRecentMessage(patient: any) {
        if (patient?.status === 'archived') return '보관된 환자 기록입니다.';
        return this.patientContentReady(patient)
            ? '환자 기록이 콘텐츠 제작을 위해 준비되었습니다.'
            : '환자 기록의 준비 상태를 확인해주세요.';
    }

    public paginationPages() {
        const total = this.totalPages;
        const current = Math.min(total, Math.max(1, Number(this.search.page) || 1));
        let start = Math.max(1, current - 2);
        let end = Math.min(total, start + 4);
        start = Math.max(1, end - 4);
        return Array.from({ length: end - start + 1 }, (_, index) => start + index);
    }

    public labelOf(options: any[], value: string) {
        return options.find((item: any) => item.value === value)?.label || '미지정';
    }

    public statusLabel(status: string) {
        return status === 'archived' ? '보관' : '활성';
    }

    public statusClass(status: string) {
        return status === 'archived'
            ? 'bg-gray-100 text-gray-600 border border-gray-200'
            : 'bg-green-50 text-green-700 border border-green-200';
    }

    public ageBand(birthYear: any) {
        if (!birthYear) return '미입력';
        const age = Math.max(0, this.currentYear - Number(birthYear));
        if (age >= 100) return '100세 이상';
        if (age < 10) return '10세 미만';
        return `${Math.floor(age / 10) * 10}대`;
    }

    public get totalPages() {
        return Math.max(1, Math.ceil(this.total / this.search.dump));
    }
}

export default PagePatientsComponent;